import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AppContext from '../../contexts/AppContext';
import { TwoColumnLayout, FormContent } from '../PrebookingSharedComponents';
import { CardContainer, SectionTitle, Field, FieldLabel, FieldValue, FieldGroup } from './SummaryShared';
import i18n from '../../i18n';

const SummaryInvoicing = ({ formData }) => {
  const { user } = useContext(AppContext);
  const ccRecipients = [user?.email, ...(formData.ccEmails || [])].filter(Boolean);

  return (
    <CardContainer>
      <TwoColumnLayout>
        <SectionTitle>{i18n('invoicing')}</SectionTitle>
        <FormContent>
          <FieldGroup>
            <Field>
              <FieldLabel>{i18n('cost_allocation')}</FieldLabel>
              <FieldValue>
                {formData.costAllocationGroup
                  ? `${formData.costAllocationGroup.name}${formData.costAllocationGroup.invoiceRecipientRef ? ` (${formData.costAllocationGroup.invoiceRecipientRef})` : ''}`
                  : '-'}
              </FieldValue>
            </Field>
            {formData.invoiceReferences?.length > 0 && (
              <Field>
                <FieldLabel>{i18n('translation_order_specifying_invoicing_details')}</FieldLabel>
                <FieldValue>{formData.invoiceReferences.join(', ')}</FieldValue>
              </Field>
            )}
            <Field>
              <FieldLabel>{i18n('additional_invoicing_information')}</FieldLabel>
              <FieldValue>{formData.additionalInvoicingInfo || '-'}</FieldValue>
            </Field>
            {ccRecipients.length > 0 && (
              <Field>
                <FieldLabel>{i18n('recipients_of_confirmation_and_change_notifications')}</FieldLabel>
                <FieldValue>{ccRecipients.join(', ')}</FieldValue>
              </Field>
            )}
          </FieldGroup>
        </FormContent>
      </TwoColumnLayout>
    </CardContainer>
  );
};

SummaryInvoicing.propTypes = {
  formData: PropTypes.object.isRequired,
};

export default SummaryInvoicing;
